// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"0aac159b","977":"79994349"}[chunkId] + ".chunk.js";
};